import React from 'react'
import PropTypes from 'prop-types'
import { Space, Tooltip, Button } from 'antd'
import { EditOutlined, UndoOutlined, RedoOutlined, CheckOutlined, PlusOutlined } from '@ant-design/icons'

const GridContextualToolbar = ({
  onValidate,
  onUndo,
  onRedo,
  undoSize,
  redoSize,
  canValidate,
  rowNumber,
  onAddRow,
}) => {
  const isEditing = !!rowNumber
  // check if using mac or pc
  const isMac = navigator.userAgent.includes('Mac')

  return (
    <div className="contextual-toolbar">
      <div className="toolbar-content">
        <div className="editing-status">
          {isEditing ? (
            <>
              <EditOutlined style={{ fontSize: '14px' }} />
              <span>Editing Row {rowNumber}</span>
            </>
          ) : (
            <span>Click any cell to edit</span>
          )}
        </div>
        <Space size="small">
          {onAddRow && (
            <Tooltip title="Add a blank row to fill in manually" placement="bottom">
              <Button
                icon={<PlusOutlined />}
                onClick={onAddRow}
                className="toolbar-button add-row-button"
                data-testid="fee-management-add-row-button"
              >
                Add Row
              </Button>
            </Tooltip>
          )}
          <Tooltip
            title={`Undo${undoSize > 0 ? ` (${undoSize} ${undoSize === 1 ? 'action' : 'actions'})` : ''}`}
            placement="bottom"
          >
            <Button
              icon={<UndoOutlined />}
              onClick={onUndo}
              disabled={undoSize === 0}
              className="toolbar-button undo-button"
            />
          </Tooltip>
          <Tooltip
            title={`Redo${redoSize > 0 ? ` (${redoSize} ${redoSize === 1 ? 'action' : 'actions'})` : ''}`}
            placement="bottom"
          >
            <Button
              icon={<RedoOutlined />}
              onClick={onRedo}
              disabled={redoSize === 0}
              className="toolbar-button redo-button"
            />
          </Tooltip>

          <div className="toolbar-divider" />

          <Tooltip
            title={canValidate ? `Validate changes (${isMac ? '⌘' : 'Ctrl'} + Enter)` : 'No changes to validate'}
            placement="bottom"
          >
            <Button
              type="primary"
              size="small"
              icon={<CheckOutlined />}
              onClick={onValidate}
              disabled={!canValidate}
              className="toolbar-button edit-action-button validate-button"
            />
          </Tooltip>
        </Space>
      </div>
    </div>
  )
}

GridContextualToolbar.propTypes = {
  onValidate: PropTypes.func.isRequired,
  onUndo: PropTypes.func.isRequired,
  onRedo: PropTypes.func.isRequired,
  undoSize: PropTypes.number.isRequired,
  redoSize: PropTypes.number.isRequired,
  canValidate: PropTypes.bool.isRequired,
  rowNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onAddRow: PropTypes.func,
}

export default GridContextualToolbar
